import {
  ConfirmContinueContext,
  ConfirmContinueProps,
} from 'Components/ConfirmContinue';
import { useCurrentPopup } from 'Components/Popups';
import { useContext, useMemo } from 'react';

export default function useConfirmContinue() {
  const { setConfig, Modal } = useContext(ConfirmContinueContext);
  // const Popup = useCurrentPopup();

  return useMemo(
    () => (config?: ConfirmContinueProps) => {
      config && setConfig(config);
      Modal.open();
    },
    [setConfig, Modal],
  );
}
